import React from 'react';
import PropTypes from 'prop-types';
import ActiveBanner from './ActiveBanner';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import useMissingFields from '@/pages/offer-manage/useMissingFields';
import DraftBanner from './DraftBanner';
import CompletedBanner from './CompletedBanner';
import CancelledBanner from './CancelledBanner';
import ExpiredBanner from './ExpiredBanner';
import { isExpired } from '@/utils/dateTimeUtils';

Banner.propTypes = {
  offer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    data: PropTypes.shape({
      creatorId: PropTypes.number,
      completed: PropTypes.bool,
      cancelled: PropTypes.bool,
      published: PropTypes.bool,
      endDate: PropTypes.string
    }).isRequired
  }).isRequired
};

export default function Banner(props) {
  const { offer } = props;

  const { missingFields } = useMissingFields(offer);

  const creator = useConnect('user.byId', {
    id: offer.data.creatorId
  });

  // return (
  //   <>
  //     <ActiveBanner
  //       offer={offer}
  //       creator={creator}
  //     />
  //     <DraftBanner
  //       offer={offer}
  //       creator={creator}
  //     />
  //     <CompletedBanner
  //       offer={offer}
  //       creator={creator}
  //     />
  //     <CancelledBanner
  //       offer={offer}
  //       creator={creator}
  //     />
  //     <ExpiredBanner
  //       offer={offer}
  //       creator={creator}
  //     />
  //   </>
  // );

  if (offer.data.completed) {
    return (
      <CompletedBanner
        offer={offer}
        creator={creator}
      />
    );
  }

  if (offer.data.cancelled) {
    return (
      <CancelledBanner
        offer={offer}
        creator={creator}
      />
    );
  }

  if (missingFields.data.length > 0) {
    return (
      <DraftBanner
        offer={offer}
        creator={creator}
      />
    );
  }

  if (isExpired(offer.data.endDate)) {
    return (
      <ExpiredBanner
        offer={offer}
        creator={creator}
      />
    );
  }

  return (
    <ActiveBanner
      offer={offer}
      creator={creator}
    />
  );
};
